import { getDefaultFunnel, resolveFunnelAlias } from "./registry";
import type { FunnelDefinition, VariantId } from "./types";

const VARIANT_ALIASES: Record<string, VariantId> = {
  a: "a",
  b: "b",
  old_testament: "a",
  ot: "a",
  flow_a: "a",
  flowa: "a",
  new_testament: "b",
  nt: "b",
  flow_b: "b",
  flowb: "b"
};

const normalizeAlias = (value: string): string => {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "_").replace(/^_+|_+$/g, "");
};

const toUrl = (urlLike: URL | string): URL => {
  const fallbackOrigin =
    typeof window === "undefined" ? "https://start.readparables.com" : window.location.origin;

  return typeof urlLike === "string" ? new URL(urlLike, fallbackOrigin) : urlLike;
};

const resolveVariantAlias = (value: string | null): VariantId | null => {
  if (!value) {
    return null;
  }

  return VARIANT_ALIASES[normalizeAlias(value)] ?? null;
};

export const resolveFunnelFromUrl = (
  urlLike: URL | string = window.location.href
): FunnelDefinition => {
  const url = toUrl(urlLike);
  const pathSegments = url.pathname.split("/").filter(Boolean);

  for (const segment of pathSegments) {
    const matchedFunnel = resolveFunnelAlias(segment);
    if (matchedFunnel) {
      return matchedFunnel;
    }
  }

  return (
    resolveFunnelAlias(url.searchParams.get("funnel")) ??
    resolveFunnelAlias(url.searchParams.get("funnel_id")) ??
    getDefaultFunnel()
  );
};

export const resolveVariantFromUrl = (
  urlLike: URL | string = window.location.href,
  funnel: FunnelDefinition = getDefaultFunnel()
): VariantId => {
  const url = toUrl(urlLike);

  const queryVariant =
    resolveVariantAlias(url.searchParams.get("variant")) ??
    resolveVariantAlias(url.searchParams.get("flow")) ??
    resolveVariantAlias(url.searchParams.get("type"));

  if (queryVariant) {
    return queryVariant;
  }

  const pathSegments = url.pathname.split("/").filter(Boolean);
  for (let index = pathSegments.length - 1; index >= 0; index -= 1) {
    const matchedVariant = resolveVariantAlias(pathSegments[index]);
    if (matchedVariant) {
      return matchedVariant;
    }
  }

  return funnel.defaultVariant;
};
